jQuery(document).ready(function( $ ) {

	function initHeader(){
		$("#site-header .mobile-menu").removeClass("open");
		$("#menu-header-nav li.menu-item.menu-item-has-children").removeClass('open');
		$("#menu-header-nav li.menu-item.menu-item-has-children").removeClass('dt-open');
		$("#menu-header-nav > li.menu-item > a").unbind();
		$("#site-header .search > svg").unbind();
		$("#site-header .mobile-menu").unbind();
		$("#menu-header-nav > li.menu-item.menu-item-has-children > a").unbind();
		$(window).unbind('scroll')
			
		if ($(window).width() >= 1182) {
			$("#site-header .header-links-container").css("display", "flex");

			// nav dropdown functionality
			$("#menu-header-nav > li.menu-item > a").hover(
				function() {
					$("li.menu-item.menu-item-has-children").removeClass("dt-open");
					if (
						$(this)
							.parent()
							.hasClass("menu-item-has-children")
					) {
						$(this)
							.parent()
							.addClass("dt-open");
					}
				},
				function() {
					$(this)
						.parent()
						.find(" > .sub-menu")
						.mouseleave(function() {
							$(this)
								.parent()
								.removeClass("dt-open");
						});
				}
			);

			// search dropdown functionality
			$("#site-header .search > svg").click(function() {
				$(this)
					.parent()
					.find(".search-form")
					.toggle();

				if (
					$(this)
						.parent()
						.find(".search-form")
						.is(":visible")
				) {
					$(document).mouseup(e => {
						const container = $(".search-form");

						// if the target of the click isn't the container nor a descendant of the container
						if (!container.is(e.target) && container.has(e.target).length === 0) {
							container.hide();
							$(document).unbind("mouseup");
						}
					});
				}
			});

			// sticky nav functionality
			window.onscroll = function() {
				if ($(window).width() >= 1182) {
					stickNav();
				}	
			};

			// Get the navbar
			var siteHeader = document.getElementById("site-header");

			// Get the offset position of the siteHeader
			var sticky = siteHeader.offsetTop;

			// Add the sticky class to the siteHeader when you reach its scroll position. Remove "sticky" when you leave the scroll position
			function stickNav() {
				if (window.pageYOffset >= sticky + 100) {
					siteHeader.classList.add("attached");
				} else {
					siteHeader.classList.remove("attached");
				}
			}
		} else {
			console.log('mobile');
			$("#site-header .header-links-container").css("display", "none");
			$(".search-form").show();
			document.getElementById("site-header").classList.remove("attached");

			// mobile nav functions
			$("#site-header .mobile-menu").click(function() {
				$(this).toggleClass("open");
				if ($(this).hasClass("open")) {
					$("#site-header .header-links-container").css("display", "flex");
				} else {
					$("#site-header .header-links-container").css("display", "none");
				}
			});

			$("#menu-header-nav > li.menu-item.menu-item-has-children > a").click(
				function(e) {
					e.preventDefault();
					$(this)
						.parent()
						.toggleClass("open");
				}
			);
		}
	}

	initHeader();
	
	var width = $(window).width(), height = $(window).height();

	$(window).resize(function(){
		
		if($(window).width() != width || $(window).height() != height){
		  initHeader();
		  width = $(window).width(), height = $(window).height();
		}
		
	});
});
